import { LineString, Point, Polygon } from "geojson";
import { LatLng } from "leaflet";

import { XYLocation } from "@nens/deck-gl";

const getPoint = (point: LatLng | XYLocation): XYLocation => {
  if ("lat" in point && "lng" in point) return [point.lat, point.lng];
  return point as XYLocation;
};

export function convertPolygonToGeometry(polygon: XYLocation[] | LatLng[]): Polygon {
  return {
    type: "Polygon",
    coordinates: [polygon.map((point) => getPoint(point))],
  };
}

export function convertLineToGeometry(line: XYLocation[] | LatLng[]): LineString {
  return {
    type: "LineString",
    coordinates: line.map((point) => getPoint(point)),
  };
}

export function convertPointToGeometry(point: XYLocation | LatLng): Point {
  return {
    type: "Point",
    coordinates: getPoint(point),
  };
}
